/**
 * Support Types
 *
 * TypeScript types for support ticket functionality.
 */

export type SupportTicketCategory =
  | "billing"
  | "technical"
  | "account"
  | "feedback"
  | "other";

export type SupportTicketPriority = "low" | "medium" | "high" | "urgent";

export type SupportTicketStatus =
  | "open"
  | "in_progress"
  | "waiting_on_customer"
  | "resolved"
  | "closed";

export interface SupportTicketMessage {
  id: string;
  ticket_id: string;
  sender_id: string | null;
  sender_email: string | null;
  sender_name: string | null;
  content: string;
  is_admin_message: boolean;
  is_internal_note: boolean;
  created_at: string;
}

export interface SupportTicketSummary {
  id: string;
  ticket_number: string;
  user_id: string;
  user_email: string;
  user_name: string | null;
  subject: string;
  category: SupportTicketCategory;
  priority: SupportTicketPriority;
  status: SupportTicketStatus;
  assigned_admin_id: string | null;
  assigned_admin_email: string | null;
  reflection_id: string | null;
  message_count: number;
  last_message_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface SupportTicketDetail {
  id: string;
  ticket_number: string;
  subject: string;
  description: string;
  category: SupportTicketCategory;
  priority: SupportTicketPriority;
  status: SupportTicketStatus;
  created_at: string;
  updated_at: string;
  resolved_at: string | null;
  closed_at: string | null;
  message_count: number;
  has_unread_admin_response: boolean;
  messages: SupportTicketMessage[];
  reflection_id: string | null;
}

export interface CreateTicketRequest {
  subject: string;
  description: string;
  category: SupportTicketCategory;
  reflection_id?: string;
}

export interface AddMessageRequest {
  content: string;
}

export interface PaginatedTicketResponse {
  items: SupportTicketSummary[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export const CATEGORY_LABELS: Record<SupportTicketCategory, string> = {
  billing: "Billing",
  technical: "Technical",
  account: "Account",
  feedback: "Feedback",
  other: "Other",
};

export const STATUS_LABELS: Record<SupportTicketStatus, string> = {
  open: "Open",
  in_progress: "In Progress",
  waiting_on_customer: "Waiting",
  resolved: "Resolved",
  closed: "Closed",
};

export const PRIORITY_LABELS: Record<SupportTicketPriority, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
  urgent: "Urgent",
};
